<template>
  <MasterDetail
    ref="masterDetail"
    :canDelete="false"
    :cols="cols"
    :confirmDeleteMessage="confirmDeleteMessage"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :resourceUrl="resourceUrl"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        divisoes: []
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "divisao_id",
          name: "Divisão",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "divisoes", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "nome",
          name: "Business Unit",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    resourceUrl() {
      return `/v1/ativacaoped/${this.clientId}/business-units`;
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getDivisoes();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
        return;
      }

      // `opts.divisoes` é carregado no `created`: na troca de empresa precisa
      // ser recarregado para o cliente novo.
      this.getDivisoes();
    }
  },
  methods: {
    confirmDeleteMessage({ divisao, nome }) {
      return `Deseja excluir o registro ${nome} — ${divisao}?`;
    },
    async getDivisoes() {
      try {
        const resource = this.apiResource(`/v1/ativacaoped/${this.clientId}/business-units-divisao/selecao`);
        const response = await resource.get();
        this.opts.divisoes = response;
      } catch (error) {
        this.opts.divisoes = [];
        
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    goToHome() {
      this.notify({
        error: 'Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada.',
      });
      this.$router.push({ name: "homepage" });
    },
  }
};
</script>
